module.exports = __webpack_public_path__ + "img/issue-4.2671138f.svg";